var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block-article-links-list',{attrs:{"title":_vm.data.title,"articles":_vm.articles,"background-color":_vm.blockColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }